//@styles
require('./hireCreditLimitModal.scss');
//@vendors
const PropTypes = require('prop-types');
const React = require('react');
//@components
const OKModal = require('components/commons/OKModal/OKModal');
const { OKMessage } = require('commonsComponents/OKMessage');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
//@utilities
const { FormattedText } = require('core/i18n').i18n;
//@constants
const {
    CARD_PAYMENT_METHOD_FIXED,
} = require('constants/index');

class HireCreditLimitModal extends React.Component {

    disableContinue () {
        const { creditLimitModalValue, immHirePaymentMethod, maxValueToAuthorize } = this.props;
        let disableContinue = false;

        if (immHirePaymentMethod.get('type')) {
            const selectedFixedType = immHirePaymentMethod.get('type') === CARD_PAYMENT_METHOD_FIXED;
            const fixedFeeAmount = immHirePaymentMethod.get('value') || 0;
            const isMaxValueToAuthorizeSelected = creditLimitModalValue === maxValueToAuthorize;
            disableContinue = selectedFixedType && fixedFeeAmount > maxValueToAuthorize && isMaxValueToAuthorizeSelected;
        }

        return disableContinue;
    }

    buildRadioButton(radioOption, index) {
        const { maxValueToAuthorize } = this.props;
        let subLabel;
        let message;

        if (!!radioOption.subLabel) {
            subLabel = (
                <FormattedText
                    value={radioOption.subLabel.translationKey}
                    className="hire-credit-limit-modal__radio-button-sub-label"
                />
            );
        }

        if (!!radioOption.message && maxValueToAuthorize > 0) {
            message = (
                <div className="hire-credit-limit-modal__radio-button-message">
                    <OKMessage type={radioOption.message.type}>
                        <FormattedText value={radioOption.message.translationKey} />
                    </OKMessage>
                </div>
            );
        }

        const label = (
            <div className="hire-credit-limit-modal-radio-button-label">
                <FormattedText
                    className="hire-credit-limit-modal-radio-button-primary-label"
                    value={radioOption.label.translationKey}
                    injectedStrings={radioOption.label.injectedStrings}
                />
                {subLabel}
                {message}
            </div>
        );

        return (
            <RadioButton
                key={index}
                label={label}
                value={radioOption.value}
                className="block-step__radio hire-credit-limit-modal__radio-button"
                overrideLabel={true}
            />
        );
    }

    getCreditOptions() {
        const {
            maxValueToAuthorize,
            creditLimit,
        } = this.props;
        let creditOptions = [
            {
                label: {
                    translationKey: 'hireCreditLimitModalComponent-approvedRequestLabel',
                    injectedStrings: [maxValueToAuthorize]
                },
                value: maxValueToAuthorize,
            },
            {
                label: {
                    translationKey: 'hireCreditLimitModalComponent-pendingRequestLabel',
                    injectedStrings: [creditLimit]
                },
                subLabel: {
                    translationKey: 'hireCreditLimitModalComponent-cardsPendingText',
                },
                value: creditLimit,
            }
        ];

        if (this.disableContinue()) {
            creditOptions[0].message = {
                translationKey: 'hireCreditLimitModalComponent-warningMessage',
                type: 'warning'
            };
        }
        return creditOptions;
    }

    getRadioOptionElements() {
        return this.getCreditOptions().map((option, index) =>
            this.buildRadioButton(option, index)
        );
    }

    render() {
        const {
            creditLimitModalValue,
            handleCreditLimitModalValueChange,
            maxValueToAuthorize,
            onRequestClose,
            onRequestContinue,
            openModal,
        } = this.props;
        const radioOptions = this.getRadioOptionElements();
        const disableContinueBtn = maxValueToAuthorize > 0 && this.disableContinue();
        const modalContent = (
            <div>
                <section>
                    <FormattedText
                        value="hireCreditLimitModalComponent-description"
                        className="hire-credit-limit-modal__message"
                    />
                    <RadioButtonGroup
                        name="selectApprovedCredit"
                        idPrefix="selectApprovedCredit"
                        selectedValue={creditLimitModalValue}
                        className="block-step__radio-group"
                        onChange={handleCreditLimitModalValueChange}
                    >
                        {radioOptions}
                    </RadioButtonGroup>
                </section>
            </div>
        );

        return (
            <OKModal 
                content={modalContent}
                footerType="navigation"
                isOpen={openModal}
                onCloseCallback={onRequestClose}
                onPrimaryButtonClick={onRequestContinue}
                onSecondaryButtonClick={onRequestClose}
                primaryButtonDisabled={disableContinueBtn}
                primaryButtonText="hireCreditLimitModalComponent-continueButton"
                secondaryButtonText="hireCreditLimitModalComponent-closeButton"
                shouldCloseOnOverlayClick={false}
                size="large"
                title="hireCreditLimitModalComponent-title"
            />
        );
    }
}

HireCreditLimitModal.defaultProps = {
    disableContinue: false
}

HireCreditLimitModal.propTypes = {
    creditLimit: PropTypes.number,
    creditLimitModalValue: PropTypes.number,
    disableContinue: PropTypes.bool,
    handleCreditLimitModalValueChange: PropTypes.func.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    maxValueToAuthorize: PropTypes.number,
    onRequestClose: PropTypes.func.isRequired,
    onRequestContinue: PropTypes.func.isRequired,
    openModal: PropTypes.bool.isRequired,
};

module.exports = HireCreditLimitModal;
